import React, { useRef, useState } from 'react'

import { useEffect } from "react";
import { matchRoutes, useLocation } from 'react-router-dom';
import "../css/Footer.css"
import { RiInstagramFill } from "react-icons/ri";
import { RiFacebookCircleFill } from "react-icons/ri";
import { RiWhatsappFill } from "react-icons/ri";
import { RiLinkedinBoxFill } from "react-icons/ri";
import { RiTwitterXFill } from "react-icons/ri";
import { IoLocationSharp } from "react-icons/io5";
import { BsFillTelephoneFill } from "react-icons/bs";
import { IoIosMail } from "react-icons/io";
import { motion, useInView } from 'framer-motion';
import { IoBook } from "react-icons/io5";
const Footer = ({ routes, showAppFooter }) => {

    const location = useLocation();
    const matchedRoutes = matchRoutes(routes, location);
    const is404 = !matchedRoutes || matchedRoutes[0].route.path === "*";
    const showFooter = location.pathname !== "/giris-yap" && location.pathname !== "/kayit-ol" && !is404;

    const [pageWidth, setPageWidth] = useState(window.innerWidth)

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;

            setPageWidth(width)
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const Nav = () => {
        return (
            <footer className='footer-body'>
                <div className="footer-body-container">
                    <motion.div
                        className="footer-sec footer-aboutus"
                        initial={{ opacity: 0, y: 30, filter: "blur(5px)" }}
                        whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                        viewport={{ once: true, amount: 0.2 }}
                        transition={{ duration: 0.5, delay: pageWidth < 1096 ? 0.50 : 0.25 }}
                    >
                        <div style={{}}>
                            <h2>Hakkımızda</h2>
                            <p>Traflux, şehir içi trafik yönetimini daha verimli ve duyarlı hale getirmek için
                                yapay zekâ ve sensör tabanlı bir trafik sinyalizasyon sistemi geliştirmeyi
                                amaçlamaktadır. Geleneksel sistemlerin sabit süre algoritmalarından
                                kaynaklanan sorunlarına çözüm olarak, ESP32 mikrodenetleyicisi, kamera modülü ve çeşitli
                                sensörler kullanılarak dinamik bir sistem tasarlanmıştır.
                            </p>
                            <h2 className='follow-us-catalogue'>Bizi Takip Edin</h2>
                            <ul className='footer-sci'>
                                <li><a href='https://www.facebook.com/people/Burak-Duyar/pfbid02MsUA1wMsNPcFMjG1EmKC5LDGa7eeY7UjNEvdhvSRvP9vjasdNiKiCwhhe74HGunfl/' target="_blank" rel="noopener noreferrer"><RiFacebookCircleFill size={30} /></a></li>
                                <li><a href='https://wa.me/+905522483700' target="_blank" rel="noopener noreferrer"><RiWhatsappFill size={30} /></a></li>
                                <li><a href='https://www.instagram.com/burak_duyar37/' target="_blank" rel="noopener noreferrer"><RiInstagramFill size={30} /></a></li>
                                <li><a href='https://www.linkedin.com/in/burak-duyar-74a053282/' target="_blank" rel="noopener noreferrer"><RiLinkedinBoxFill size={30} /></a></li>
                                <li><a href='https://x.com/burak37duyar' target="_blank" rel="noopener noreferrer"><RiTwitterXFill size={25} /></a></li>
                            </ul>
                        </div>
                    </motion.div>
                    <motion.div
                        className="footer-sec footer-products"
                        initial={{ opacity: 0, y: 30, filter: "blur(5px)" }}
                        whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                        viewport={{ once: true, amount: 0.2 }}
                        transition={{ duration: 0.8, delay: pageWidth < 1096 ? 0.50 : 0.50 }}
                    >
                        <h2>Trafik Akışı</h2>
                        <div className="menu-container">
                            <div className="column">
                                <ul>
                                    <li><a href='/trafik-akisi'>Trafik Akışımız</a></li>
                                </ul>
                            </div>

                        </div>
                    </motion.div>
                    <motion.div
                        className="footer-sec footer-contact"
                        initial={{ opacity: 0, y: 30, filter: "blur(5px)" }}
                        whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                        viewport={{ once: true, amount: 0.2 }}
                        transition={{ duration: 0.5, delay: pageWidth < 1096 ? 0.50 : 0.75 }}
                    >
                        <h2>İletişim Bilgilerimiz</h2>
                        <ul className='info'>
                            <li >
                                <span><IoLocationSharp size={20} /></span>
                                <span>ATLAS VADİ KAMPÜSÜ 2020 ANADOLU CAD. <br />
                                    NO:40 KAĞITHANE/İSTANBUL</span>
                            </li>
                            <li>
                                <span><BsFillTelephoneFill size={18} /></span>
                                <p><a href='tel:+905522483700'>+90 552 248 3700</a></p>
                            </li>
                            <li>
                                <span><IoIosMail size={22} /></span>
                                <p><a href='mailto:info@trafluxx.com'>info@trafluxx.com</a></p>
                            </li>
                        </ul>
                    </motion.div>
                </div >
            </footer >
        )
    }

    const Section2 = () => {
        return (
            <div className="footer-copyrightText">
                <p>© Copyright 2025 Traflux. Tüm Hakları Saklıdır.</p>
            </div>
        )
    }

    if (!showFooter || !showAppFooter) {
        return (
            <div></div>
        )
    }
    else {
        return (
            <div className="footer-container">
                <div className="footer-fixed">
                    <div className="footer-background">
                        <Nav />
                        <Section2 />
                    </div>
                </div>
            </div>
        )
    }
}

export default Footer